import { Injectable } from '@angular/core';
import { AlertService } from './alert.service';

type LeaveConfirmationHandler = () => boolean | Promise<boolean>;

@Injectable({
    providedIn: 'root',
})
export class QuotationUnsavedChangesService {
    private leaveConfirmationHandler: LeaveConfirmationHandler | null = null;
    private skipNextConfirmation = false;

    constructor(private readonly alertService: AlertService) {}

    register(handler: LeaveConfirmationHandler): void {
        this.leaveConfirmationHandler = handler;
    }

    unregister(handler?: LeaveConfirmationHandler): void {
        if (!handler || this.leaveConfirmationHandler === handler) {
            this.leaveConfirmationHandler = null;
        }
    }

    /** Skip the next route-guard prompt after the user already confirmed leaving (e.g. logout). */
    markLeaveConfirmed(): void {
        this.skipNextConfirmation = true;
    }

    consumeSkipConfirmation(): boolean {
        if (!this.skipNextConfirmation) {
            return false;
        }
        this.skipNextConfirmation = false;
        return true;
    }

    /** Close an open leave-confirmation dialog when socket/API refreshes the page. */
    dismissLeaveConfirmation(): void {
        this.skipNextConfirmation = false;
        this.alertService.closeConfirmIfOpen();
    }

    confirmLeaveIfNeeded(): Promise<boolean> {
        if (!this.leaveConfirmationHandler) {
            return Promise.resolve(true);
        }
        return Promise.resolve(this.leaveConfirmationHandler()).then((confirmed) => {
            if (confirmed) {
                this.markLeaveConfirmed();
            }
            return confirmed;
        });
    }
}
